export default __webpack_public_path__ + "static/media/serviciosAlarma3.e762668e.png";